import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function InvestmentSection() {
  return <section className="py-24 bg-slate-900 text-white" data-id="element-148">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-149">
        <h2 className="text-3xl md:text-4xl font-bold mb-12" data-id="element-150">
          Professional Marketing System
        </h2>

        <div className="bg-slate-800 rounded-3xl p-10 md:p-16 shadow-2xl border border-slate-700 relative overflow-hidden" data-id="element-151">
          {/* Background decoration */}
          <div className="absolute top-0 right-0 -mr-16 -mt-16 w-64 h-64 bg-emerald-500/10 rounded-full blur-3xl" data-id="element-152"></div>
          <div className="absolute bottom-0 left-0 -ml-16 -mb-16 w-64 h-64 bg-orange-500/10 rounded-full blur-3xl" data-id="element-153"></div>

          <div className="relative z-10" data-id="element-154">
            <div className="flex items-baseline justify-center mb-4" data-id="element-155">
              <span className="text-xl md:text-2xl text-slate-400 font-medium mr-2" data-id="element-156">
                Starting at
              </span>
              <span className="text-5xl md:text-7xl font-extrabold text-white tracking-tight" data-id="element-157">
                $997
              </span>
              <span className="text-xl md:text-2xl text-slate-400 font-medium ml-2" data-id="element-158">
                /month
              </span>
            </div>

            <p className="text-xl text-slate-300 mb-8 font-light" data-id="element-159">
              Complete setup • Ongoing optimization • Proven results
            </p>

            <div className="inline-block bg-emerald-500/20 border border-emerald-500/30 rounded-lg px-6 py-3 mb-10" data-id="element-160">
              <p className="text-emerald-400 font-semibold flex items-center gap-2" data-id="element-161">
                <CheckCircle2 className="w-5 h-5" data-id="element-162" />
                No long-term contracts - see results or pause anytime
              </p>
            </div>

            <a href="https://api.viridiaanalytics.com/widget/booking/hv5pIfS27zbJCMMGNnkJ" target="_blank" rel="noopener noreferrer" className="inline-block w-full md:w-auto px-10 py-4 bg-orange-600 hover:bg-orange-500 text-white text-lg font-bold rounded-full transition-all shadow-lg hover:shadow-orange-500/25 transform hover:scale-105" data-id="element-163">
              Get Started Today
            </a>

            <p className="mt-6 text-sm text-slate-500" data-id="element-164">
              Custom packages available for larger operations
            </p>
          </div>
        </div>
      </div>
    </section>;
}